export const LOAD = 'ethstats/blockPropagation/LOAD';
export const LOAD_SUCCESS = 'ethstats/blockPropagation/LOAD_SUCCESS';
export const LOAD_FAIL = 'ethstats/blockPropagation/LOAD_FAIL';
